import { Formio } from "formiojs";

export const tokenValidationMixin = {
  methods: {
    async isTokenValid() {
      const formioURL = process.env.VUE_APP_FORMIO_URL + "/current";

      let response = await fetch(formioURL, {
        headers: { "x-jwt-token": localStorage.getItem("formioToken") }
      });

      return response.status === 200;
    },
    logout() {
      Formio.logout();
      this.$store.dispatch("resetCounts");
      this.$store.commit("logout");
      this.$router.push("/sign-in");
    }
  }
};
